/* eslint-disable camelcase */
import ReactGA from 'react-ga4';

const trackPageView = (page_title) => {
  ReactGA.send({
    hitType: 'pageview',
    page_title,
  });
};

const trackEvent = (eventName, params = {}) => {
  ReactGA.event(eventName, params);
};

const failryMadeLink = (reference = '') => {
  trackEvent('fairly_made_link_click', { reference });
};

export { trackPageView, trackEvent, failryMadeLink };
